import React from "react";
import { styled } from "@mui/material/styles";
import { TextField, TextFieldProps } from "@mui/material";

const Input = styled(TextField)({
  width: "100%",
  backgroundColor: "transparent",
  position: "relative",
  "& .MuiInputLabel-root": {
    position: "absolute",
    top: "calc(50% - 14px)",
    left: "20px",
    fontSize: "18px",
    lineHeight: "30px",
    fontWeight: 500,
    color: "rgba(136, 136, 126, 0.26)",
    fontFamily: "'Inter', sans-serif",
    transform: "none",
    transition: "top 0.2s ease, font-size 0.2s ease, line-height 0.2s ease",
    "&.Mui-error": {
      color: "var(--red)",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "rgba(107, 107, 107, 1)",
    fontSize: "12px",
    lineHeight: "12px",
    top: "10px",
  },
  "& .MuiInput-root": {
    margin: 0,
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "19px",
    color: "var(--black)",
    fontFamily: "'Inter', sans-serif",
    border: "1px solid var(--border-color)",
    borderRadius: "15px",
    "&.Mui-error": {
      borderColor: "var(--red)",
    },
    "&::before, &::after": {
      display: "none !important",
    },
  },
  "& .MuiInput-root.Mui-focused": {
    padding: "17px 20px 3px",
  },
});

export default function TextInput(props: TextFieldProps) {
  const { InputProps, ...rest } = props;
  return (
    <Input
      variant="standard"
      InputLabelProps={{
        shrink: true,
        className:
          props?.value || props?.value === 0 || props?.defaultValue
            ? "Mui-focused"
            : "",
      }}
      InputProps={{
        ...InputProps,
        className:
          props?.value || props?.value === 0 || props?.defaultValue
            ? "Mui-focused"
            : "",
      }}
      {...rest}
      placeholder=""
    />
  );
}
